import React from "react";
import routeGuard from "src/HOC/routeGuard";
import TestAnalysisList from "src/components/TestAnalysis/list";
import { RESOURCE_TYPE } from "src/constant/common";

const TestAnalysis = () => {
  return (
    <TestAnalysisList />
  );
};

export default routeGuard(TestAnalysis, RESOURCE_TYPE.TEST_ANALYSIS);
